<div [formGroup]="form">
        <!-- Non-inline -->
        <nz-form-item *ngIf="inline == false">
                <nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required">
                        {{ wrapper.element.name }}
                </nz-form-label>

                <nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required">
                        {{ wrapper.element.name }}
                </nz-form-label>

                <nz-form-control [nzAutoTips]="wrapper.autoTips">
                        <nz-select [formControlName]="toControlKey(wrapper.element)"
                                nzPlaceHolder="Search service provider..." nzShowSearch nzAllowClear nzServerSearch
                                [nzDisabled]="readonly" [nzLoading]="isLoading" (nzOnSearch)="onSearch($event)">
                                <nz-option *ngFor="let opt of suggestions" [nzValue]="opt.id + ''"
                                        [nzLabel]="getLabel(opt)" nzCustomContent>
                                        <div class="service-provider-option"
                                                (mousedown)="selectServiceProvider(opt, $event)">
                                                {{ getLabel(opt) }}
                                        </div>
                                </nz-option>
                        </nz-select>
                </nz-form-control>
        </nz-form-item>

        <!-- Inline -->
        <nz-form-item *ngIf="inline == true">
                <nz-form-control [nzAutoTips]="wrapper.autoTips">
                        <nz-select [formControlName]="toControlKey(wrapper.element)"
                                nzPlaceHolder="Search service provider..." nzShowSearch nzAllowClear nzServerSearch
                                [nzDisabled]="readonly" [nzLoading]="isLoading" (nzOnSearch)="onSearch($event)">
                                <nz-option *ngFor="let opt of suggestions" [nzValue]="opt.id + ''"
                                        [nzLabel]="getLabel(opt)" nzCustomContent>
                                        <div class="service-provider-option"
                                                (mousedown)="selectServiceProvider(opt, $event)">
                                                {{ getLabel(opt) }}
                                        </div>
                                </nz-option>
                        </nz-select>
                </nz-form-control>
        </nz-form-item>
</div>